import { render, staticRenderFns } from "./OverflowIcon.vue?vue&type=template&id=53a1450b&scoped=true&"
import script from "./OverflowIcon.vue?vue&type=script&lang=js&"
export * from "./OverflowIcon.vue?vue&type=script&lang=js&"
import style0 from "./OverflowIcon.vue?vue&type=style&index=0&id=53a1450b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a1450b",
  null
  
)

export default component.exports